import { memo } from 'react';
import { Tooltip } from '@ds';
import { MdInfoOutline } from 'react-icons/md';
import { ArrivalLabel } from '../../types';

const ARRIVAL_TOOLTIP_TEXT: Record<ArrivalLabel, string> = {
  'Organ ETA': 'Estimated Time of Arrival to TX Center',
  'Organ STA': 'Scheduled Time of Arrival to TX Center',
};

type ETADisplayProps = {
  etaDate?: string | null;
  etaTime?: string | null;
  etaTz?: string | null;
  arrivalLabel?: ArrivalLabel;
  txCenterOrTime?: string | null;
  txCenterOrTz?: string | null;
};

export const ETADisplay = memo(
  ({ etaDate, etaTime, etaTz, arrivalLabel = 'Organ STA', txCenterOrTime, txCenterOrTz }: ETADisplayProps) => {
    const displayTime = etaTime || '--:--';
    const displayTz = etaTz || '';

    return (
      <div className="flex flex-col items-end gap-1 flex-1">
        {txCenterOrTime ? (
          <span className="text-s-r whitespace-nowrap">
            TX Center OR: <span className="text-maroon-20">{txCenterOrTime}</span>
            {txCenterOrTz ? <span className="text-maroon-20">&nbsp;{txCenterOrTz}</span> : ''}
          </span>
        ) : null}
        <span className="flex text-s-m text-base-5">
          {arrivalLabel}
          <Tooltip
            content={
              <div className="max-w-[320px]">
                <span className="text-s-r">{ARRIVAL_TOOLTIP_TEXT[arrivalLabel]}</span>
              </div>
            }
          >
            <div>
              <MdInfoOutline size={16} className="text-base-25 ml-1" />
            </div>
          </Tooltip>
        </span>
        <div className="flex items-center gap-1">
          <span className="text-xl-sb text-base-5 whitespace-nowrap">
            {etaDate ? <span>{etaDate}&nbsp;</span> : ''}
            {displayTime} {displayTz ? <span>{displayTz}</span> : ''}
          </span>
        </div>
      </div>
    );
  },
);
